import { PAYMENT_METHOD_KEYS, PAYMENT_METHOD_VALUES } from "./paymentTypes";

/**
 * Admin reservation payment options (cash, card gateway, send payment link).
 * Cash is only offered when the company enabled `preferences.showCashPayment`.
 */
export const buildAdminPaymentOptions = ({ defaultPaymentGateway = "stripe", showCashPayment = false, t }) => {
    const gateway = defaultPaymentGateway || "stripe";

    return [
        ...(showCashPayment
            ? [
                  {
                      key: PAYMENT_METHOD_KEYS.CASH,
                      value: PAYMENT_METHOD_VALUES.CASH,
                      title: t("reservationPayment:cash.title"),
                      description: t("reservationPayment:cash.description"),
                  },
              ]
            : []),
        {
            key: PAYMENT_METHOD_KEYS.CARD,
            value: gateway,
            title: t("reservationPayment:card.title"),
            description: t("reservationPayment:card.description"),
        },
        {
            key: PAYMENT_METHOD_KEYS.SEND_LINK,
            value: PAYMENT_METHOD_VALUES.SEND_LINK,
            title: t("reservationPayment:sendLink.title"),
            description: t("reservationPayment:sendLink.description"),
        },
    ];
};

export const getDefaultPaymentMethod = (options) => options[0]?.value ?? null;
